import { MDBCol, MDBRow } from "mdb-react-ui-kit";
import { NextPage } from "next";
import Image from "next/image";
import { shallow } from "zustand/shallow";
import Link from "next/link";
import styles from "../../../styles/userPage/userPage.module.scss";
import { TAccountModel } from "../../../models/userPage";
import { useStore } from "../../../store";

const YourAccountPage: NextPage = () => {
    const {
        name,
        surname,
        address,
        language,
        instagram,
        twitter,
        facebook,
        bio,
    } = useStore(
        state => ({
            name: state.userState.userDetail.name,
            surname: state.userState.userDetail.surname,
            bio: state.userState.userDetail.bio,
            address: state.userState.userDetail.address,
            language: state.userState.userDetail.language,
            instagram: state.userState.userDetail.usernameInstagram,
            twitter: state.userState.userDetail.usernameTwitter,
            facebook: state.userState.userDetail.usernameFacebook,
        }),
        shallow
    );

    const accountData: TAccountModel[] = [
        {
            iconName: "/images/Home/Line.svg",
            title: "Lives in",
            description: address ?? "",
        },
        {
            iconName: "/images/Line.svg",
            title: "Speaks",
            description: language ?? "",
        },
    ];

    const getSocialButton = (path: string | undefined, root: string) =>
        path ? (
            <MDBCol size={2} lg={1}>
                <Link href={`https://www.${root}.com/${path}`}>
                    <Image
                        src={`/images/${root}/Line.svg`}
                        width={25}
                        height={25}
                        alt=""
                    />
                </Link>
            </MDBCol>
        ) : null;

    const getAccountRow = (body: TAccountModel) => {
        return (
            <MDBCol size={12} lg={6}>
                <MDBRow>
                    <MDBCol size={1}>
                        <Image
                            src={body.iconName}
                            width={23}
                            height={23}
                            alt=""
                        />
                    </MDBCol>
                    <MDBCol size={3} lg={3}>
                        <p className={styles.accountTitleDetail}>
                            {body.title}
                        </p>
                    </MDBCol>
                    <MDBCol size={8} lg={8}>
                        <p className={styles.accountDetail}>
                            {body.description}
                        </p>
                    </MDBCol>
                </MDBRow>
            </MDBCol>
        );
    };

    return (
        <div>
            <h2 className={`${styles.accountTitle}`}>
                About {`${name || ""} ${surname || ""}`}
            </h2>
            <p className={`${styles.accountDecription}`}>{bio}</p>

            {accountData
                .filter(curr => curr.description)
                .map(member => (
                    <div key={`${member.title}-${member.iconName}`}>
                        {getAccountRow(member)}
                    </div>
                ))}
            <MDBCol size={10}>
                <MDBRow>
                    {getSocialButton(twitter, "Twitter")}

                    {getSocialButton(instagram, "Instagram")}

                    {getSocialButton(facebook, "Facebook")}
                </MDBRow>
            </MDBCol>
        </div>
    );
};

export default YourAccountPage;
